import { DownOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { animated, useSpring } from 'react-spring';

import './ExpandableContent.scss';

export default function ExpandableContent({
  title,
  titleClassName = null,
  withArrow = false,
  arrowPosition = 'right',
  variant = 'default',
  defaultExpanded = false,
  children,
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);
  const hasToggled = useRef(false);

  const toggle = () => {
    hasToggled.current = true;
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      setHeight(entry.contentRect.height);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const props = useSpring({
    height: isExpanded ? height : 0,
    config: { tension: 170, friction: 26 },
    immediate: !hasToggled.current,
  });

  const isPanel = variant === 'panel';
  const isBar = variant === 'bar';

  const arrowButton = (
    <Button type='text' size='large' className={`btn-icon${isExpanded ? ' expanded' : ''}${isBar || isPanel ? ' btn-dark' : ''}`} icon={<DownOutlined />} />
  );

  if (isPanel) {
    return (
      <div className={`expandable-panel${isExpanded ? ' expanded' : ''}`}>
        <Flex className='expandable-panel-header' onClick={toggle} align='center' gap={4}>
          {arrowButton}
          <p className={titleClassName || 'sub1'}>{title}</p>
        </Flex>
        <animated.div
          className='expandable-content'
          style={{
            overflow: 'hidden',
            height: props.height.to((h) => `${h}px`),
          }}
        >
          <div ref={contentRef}>
            <div className='expandable-panel-body'>{children}</div>
          </div>
        </animated.div>
      </div>
    );
  }

  return (
    <div className='expandable-wrapper'>
      {withArrow ? (
        <Flex
          className={`expandable-link${isBar ? ' py-[4px] px-s border-0 border-b border-solid border-grey bg-grey-light' : ''}`}
          onClick={toggle}
          justify='space-between'
          align='center'
        >
          {arrowPosition === 'left' && arrowButton}
          <p className={titleClassName ? titleClassName : 'sub1'}>{title}</p>
          {arrowPosition === 'right' && arrowButton}
        </Flex>
      ) : (
        <Button className='expandable-link' type='link' onClick={toggle}>
          <span className={titleClassName}>{title}</span>
        </Button>
      )}
      <animated.div
        className='expandable-content'
        style={{
          overflow: 'hidden',
          height: props.height.to((h) => `${h}px`),
        }}
      >
        <div ref={contentRef}>{children}</div>
      </animated.div>
    </div>
  );
}
